import { AlignStick } from "../../shared";
import { useTheme } from "../..";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";

const StickyBar = () => {
  const navigate = useNavigate();
  const { zip } = useZipRootLoaderData();
  const { sticky } = useTheme();

  const cells = useMemo(() => {
    const data = structuredClone(sticky);

    while (data.length < 3) {
      data.push("");
    }

    return data;
  }, [sticky]);

  if (sticky.length < 1) {
    return null;
  }

  const cleanDoctors = () => {
    sessionStorage.removeItem("planDoctorsToCompare");
    navigate({
      pathname: "/compare-plans",
      search: `?zipcode=${zip}`,
    });
  };

  return (
    <div
      className="background-quaternary"
      style={{ position: "fixed", bottom: 0, width: "100%", zIndex: 999 }}
    >
      <div className="grid-container" style={{ padding: "16px 20px" }}>
        <p>Add 2-3 plans to compare side by side</p>
        <div className="grid-x align-middle">
          <div className="cell small-12 large-10">
            <div className="grid-x grid-margin-x align-center">
              {cells.slice(0, 3).map((item: any, index: number) => (
                <AlignStick key={index} data={item} />
              ))}
            </div>
          </div>
          <div className="cell small-12 large-2 text-right align-center">
            <button
              type="button"
              onClick={cleanDoctors}
              disabled={sticky.length < 2}
              className="button"
              style={{
                marginBottom: "0px",
                padding: "13px 15px",
                fontSize: "18px",
                fontWeight: 700,
                backgroundColor: sticky.length < 2 ? "#CACACA" : "#1B54C2",
              }}
            >
              Compare Plans
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyBar;
